import styled, { keyframes } from 'styled-components';

type Props = {
  global: boolean;
}

const spinnerAnimation = keyframes`
  0% { transform: rotate(0deg) }
  100% { transform: rotate(360deg) }
`;

export const StyledSpinner = styled.div`
  border: 3px solid #9b9b9b;
  border-top-color: lightgray;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: ${spinnerAnimation} 0.8s linear infinite;
`;

export const SpinnerWrapper = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => (props.global ? '80vh' : 'auto')};
`;
